module.exports = __webpack_public_path__ + "static/media/pagination-first-disabled.4e120ea8.svg";